/*
 * @Author: Teemo Ding
 * @Date: 2021-06-23 15:42:12
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-02-24 10:17:43
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Label/index.tsx
 */

import React, { ReactNode } from 'react';
import { Form } from 'antd';
import { isString, isArray } from 'lodash';
import CountWords from '@/src/components/CountWords/CountWords';
import css from './css.module.less';
interface labelProps {
  title?: string | ReactNode;
  rightSubTitle?: string;
  bottomTitle?: string;
  titleContainerClassName?: string;
  bottomTitleContainerClassName?: string;
  textLength?: number;
  nameKey?: any;
}

const label = ({
  title,
  rightSubTitle,
  bottomTitle,
  titleContainerClassName,
  bottomTitleContainerClassName,
  textLength,
  nameKey,
}: labelProps) => {
  return (
    <div className={`${css.titleContainer} ${titleContainerClassName || ''}`}>
      <div className={css.mainTitleContainer}>
        <div className={css.upperTitleContainer}>
          {title && <div className={css.title}>{title}</div>}

          {rightSubTitle && (
            <div className={css.rightSubTitle}>{rightSubTitle}</div>
          )}
        </div>
        {bottomTitle && (
          <div
            className={
              css.bottomTitleContainer + ' ' + bottomTitleContainerClassName ||
              ''
            }>
            {bottomTitle}
          </div>
        )}
      </div>
      {textLength && nameKey && (
        <Form.Item
          className={css.noMargin}
          shouldUpdate={(prevValues, curValues) => {
            if (isString(nameKey)) {
              return prevValues[nameKey] !== curValues[nameKey];
            } else if (isArray(nameKey)) {
              return (
                ((prevValues[nameKey[0]] || {})[nameKey[1]] || {})[
                  nameKey[2]
                ] !==
                ((curValues[nameKey[0]] || {})[nameKey[1]] || {})[nameKey[2]]
              );
            }
          }}>
          {({ getFieldValue }) => {
            const value = getFieldValue(nameKey);
            return (
              <CountWords count={(value || '').length} allCount={textLength} />
            );
          }}
        </Form.Item>
      )}
    </div>
  );
};

export default label;
